import { createStore } from 'vuex'

import getters from './getters'
import app from './modules/app'
import leafletDetails from './modules/leafletDetails'
import leafletsOrder from './modules/leafletsOrder'
import shops from './modules/shops'
import tagsView from './modules/tagsView'
import user from './modules/user'

const store = createStore({
  modules: {
    app,
    tagsView,
    user,
    shops,
    leafletDetails,
    leafletsOrder
  },
  getters
})

export default store
